import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import './UnSubscriptionModal.css'
import '../../../assets/css/modal.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
const UnSubscriptionModal = ({ showUnSubscriptionModal, setShowUnSubscriptionModal,searchParams,setSearchParams }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowUnSubscriptionModal(false);
    searchParams.delete('status');
    setSearchParams(searchParams);
  }

  useEffect(() => {
    // let msisdn = null;

    // if (playerData?.id) {
    //   msisdn = playerData?.msisdn;
    // }
    // activityLogSubmission("contacts", msisdn);
    // analyticEvent('contact', 'contact-view')
  }, [])


  return (
    <>
      <Modal show={showUnSubscriptionModal} centered dialogClassName="modal-dialog" contentClassName="modalContent" onHide={hideModalOperation}>
        <Modal.Header closeButton>
          <Modal.Title>আনসাবস্ক্রিপশন</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <span className='modalSubsCustom'>  আপনি সফলভাবে আনসাবস্ক্রাইবড হয়েছেন। </span>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default UnSubscriptionModal